import React from 'react';
import { FormikProps } from 'formik';
import { genericCreateTariffChargePayload } from '../../../../../../models/entities/tariff/charge';
import FormInputWrapper from '../../../../../shared/Form/FormInputWrapper';
import { FormNumberInput } from '../../../../../shared/inputs/form';
import { currencyFormatter } from '../../../../../shared/inputs/form/CurrencyInput/CurrencyInput';
import { numberParser } from '../../../../../shared/inputs/form/NumberUnitInput';

export const emptyFlatCalcData = {
    price: 0
};

type Props = {
    localization: any;
    formikProps: FormikProps<genericCreateTariffChargePayload<'FLAT'>>;
};

const Flat = ({ formikProps, localization }: Props) => {
    const { values } = formikProps;
    return (
        <FormInputWrapper fieldName="price" localization={localization.fields} isMandatory>
            <FormNumberInput
                name="chargeCalcData.price"
                formatter={currencyFormatter(values.currency)}
                parser={numberParser}
                style={{ width: '200px', marginRight: '15px' }}
            />
        </FormInputWrapper>
    );
};

export default Flat;
